import { render } from "./OptionsModal.vue?vue&type=template&id=3ae15d20&scoped=true&ts=true"
import script from "./OptionsModal.vue?vue&type=script&lang=ts"
export * from "./OptionsModal.vue?vue&type=script&lang=ts"

import "./OptionsModal.vue?vue&type=style&index=0&id=3ae15d20&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae15d20"]])

export default __exports__